import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "../Screens/Common/UseDebounce/useDebounce";

export const usePaginationState = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [country, setCountry] = useState<string | null>("");
  const [state, setState] = useState<string | null>("");
  const [city, setCity] = useState<string | null>("");

  // Debounced Search

  const debouncedSearch = useDebounce(search);

  // Sync State when URL changes (Back/Forward Fix)
  useEffect(() => { 
    // const urlPage = Number(searchParams.get("page")) || 1;
    // const urlSearch = searchParams.get("search");
    // const urlCountry = searchParams.get("country");
    // const urlState = searchParams.get("state");
    // const urlCity = searchParams.get("city");
    // setSearch(urlSearch ?? "");
    // setCountry(urlCountry??"");
    // setState(urlState??"");
    // setCity(urlCity??"");
    // setPage(urlPage);
  }, [searchParams]);

  useEffect(() => {
    
    setSearchParams({
      page: "1",
      search: debouncedSearch,
      country: country || "",
      state: state || "",
      city: city || "",
    });
  }, [debouncedSearch, country, state, city]);

  // Page Change Handler
  const handlePageChange = (newPage: number) => {
    setPage(newPage)
    setSearchParams({
      page: newPage.toString(),
      search,
      country: country || "",
      state: state || "",
      city: city || "",
    });
  };

  return {
    page,
    search,
    setSearch,
    debouncedSearch,
    handlePageChange,
    setPage,
    country,
    setCountry,
    state,
    setState,
    city,
    setCity,

  };
};
